import ingeoService from './ingeo'
import { TokenService } from './storage.service'

const zonaService = {}


zonaService.index = function () {
    const token = TokenService.getToken()
    const requestHeaders = {'Authorization': token, 'content-type': 'application/json'}
    return ingeoService.get('zonas', {headers: requestHeaders}
     ).then(function (res) {
        return res
    })
}

zonaService.zonaput = function (zonaElegida, criterioElegido, fechadesde, fechahasta){
  const token = TokenService.getToken()
  const requestHeaders = {'Authorization': token, 'content-type': 'application/json'}
  return ingeoService.get('zonaput/' +fechadesde + '/' +fechahasta + '/' + zonaElegida + '/' + criterioElegido, {headers: requestHeaders}
  ).then(function (res) {
      return res
  })
}

zonaService.checkQueryState = function (id){
  const token = localStorage.getItem('userToken')
  const requestHeaders = {'Authorization': token, 'content-type': 'application/json'}
  return ingeoService.get('zonarep' + '?id=' + id, {headers: requestHeaders}
  ).then(function (res){
    return res
  })
}

zonaService.showQueryDetail = function (index, row){
    const token = localStorage.getItem('userToken')
    const requestHeaders = {'Authorization': token, 'content-type': 'application/json'}
    return ingeoService.get('zonarepitem/' + row.id, {headers: requestHeaders}
    ).then(function (res){
        return res
    } )
}


zonaService.getData = function (){
  const token = TokenService.getToken()
  const requestHeaders = {'Authorization': token, 'content-type': 'application/json'}
  return ingeoService.get('zonarep',{headers: requestHeaders}
  ).then(function (res) {
    return res
  })
}



zonaService.route = function (pat) {
  const token = localStorage.getItem('userToken')
  const requestHeaders = { 'content-type': 'application/json', 'Authorization': token }
  const requestParams = { limit: 100 }

  return ingeoService.get('vehiculos/' + pat + '/coordenadas', {
      headers: requestHeaders,
      params: requestParams
    }
   ).then(function (res) {
      return res
  })
}

zonaService.checkQueryState = function (id) {
  const token = TokenService.getToken()
  const requestHeaders = {'Authorization': token, 'content-type': 'application/json'}
  return ingeoService.get('zonarep'+ '?id=' + id, {headers: requestHeaders}
  ).then(function (res) {
    return res
  })
}


export default zonaService;
